import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import rawCountries from 'shared/FormControls/RawCountries';
import moment from 'moment';
import * as Yup from "yup";
import printJS from "print-js";
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import { Grid, Tooltip } from '@mui/material';

export const authRole = {
  admin: ['admin'],
  user: ['user', 'admin'],
};

export const defaultUser = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'user',
  photoURL: 'https://via.placeholder.com/150',
};

export const defaultSuperAdmin = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'super_admin',
  photoURL: 'https://via.placeholder.com/150',
};

export const perPage = 500;

// export const lbsValue=2.20462262185;
export const lbsValue = 2.2;

export const initialUrl = '/shipper/quotation/create';
// export const initialUrl ='/super-admin/freight-forwarder/admins/list/view'

export const packgingNames = [
  'Envelope',
  'Pak',
  'Pallet',
  'Skid',
  'Bag',
  'Bale',
  'Barrel',
  'Basket',
  'Bin',
  'Box',
  'Bounch',
  'Bundle',
  'Cabinet',
  'Can',
  'Carboy',
  'Carrier',
  'Carton',
  'Case',
  'Cask',
  'Container',
  'Crate',
  'Cylinder',
  'Drum',
  'Jerrican',
  'Loose',
  'Other',
  'Package',
  'Pail',
  'Pieces',
  'Pipe Line',
  'Reel',
  'Roll',
  'Spool',
  'Tank',
  'Totes',
  'Tube',
  'Unit',
  'Van Pack',
  'Wrapped',
];

export const editQuote = {
  greenColor: '#91d7a2',
  purpleColor: '#c491f0',
  salmonColor: '#ffc6af',
  pinkColor: '#ffb2ff',
  lightBlueColor1: '#cee1f4',
  lightBlueColor2: '#b6d2ee',
  lightBlueColor3: '#9dc3e9',
  lightBlueColor4: '#85b4e4',
  lightBlueColor5: '#77a2cd',
};

export const textStyle = {
  fontSize: '16px',
  color: '#495057',
  fontFamily: 'Poppins,sans-serif',
  paddingTop: '15px',
};

export const handleNegativeValue = (event) => {
  const allowedCharacters = /[0-9.,]/;
  const inputChar = String.fromCharCode(event.keyCode || event.which);

  // if (event?.key === '-' || event?.key === '+' || !allowedCharacters.test(inputChar)) {
  if (event.key === '-' || !allowedCharacters.test(inputChar)) {
    event.preventDefault();
  }
};

export const handleNegativeValueAllowPlusAndMinu = (event) => {
  const allowedCharacters = /[0-9.,-]/;
  const inputChar = String.fromCharCode(event.keyCode || event.which);

  if (event?.key === '-0' || !allowedCharacters.test(inputChar)) {
    event.preventDefault();
  }
};

export const handleAmountFormat = (value) => {
  return parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2 });
};

export const toastDelay = 4500;

export const hazamatClass = [
  '1.1',
  '1.1G',
  '1.2',
  '1.2G',
  '1.3',
  '1.3G',
  '1.4',
  '1.4B',
  '1.4C',
  '14G',
  '1.4S',
  '1.5',
  '1.6',
  '2.1',
  '2.2',
  '2.2(5.1)',
  '2.3',
  '3',
  '3(6.1)',
  '3(8)',
  '4.1',
  '4.2',
  '4.3',
  '4.3(3)(8)',
  '4.3(8)(3)',
  '5.2',
  '5.1(8)',
  '5.1',
  '6.1',
  '6.1(3)',
  '6.1(5.1)',
  '6.1(8)',
  '6.1(8)(3)',
  '6.2',
  '8',
  '8(3)',
  '8(5.1)',
  '8(6.1)',
  '9',
];

export const typeOfGoodNames = [
  'General Cargo',
  'Dangerous Goods',
  'Express Cargo',
  'Temperature Controlled Cargo',
  'Perishable Cargo',
  'Oversized Cargo',
];

export const chooseUnitNames = ['Imperial / Metric', 'Imperial', 'Metric'];

export const packingGroupNames = ['I', 'II', 'III', 'None'];

export const chooseShipper = ['Known Shipper', 'Unknown Shipper'];
export const stackableNames = ['Yes', 'No'];
export const hazmatNames = ['Yes', 'No'];
export const screenedNames = ['Yes', 'No'];
export const turnableNames = ['Yes', 'No'];
export const frieghtNames = ['Yes', 'No'];
export const chargeableNames = ['Yes', 'No'];

// Function to get the dialing code for a given country code
export const getDialingCodeFromCountryCode = (countryCode) => {
  let conutryDialCode = '';

  rawCountries.forEach((item) => {
    if (countryCode === item?.[2]) {
      conutryDialCode = item?.[3] ? `+${item?.[3]}` : '';
    }
  });
  return conutryDialCode;
};

// // Function to format the phone number with the dialing code
export const formatPhoneNumberWithDialingCode = (mobileNumber) => {
  // const dialingCode = getDialingCodeFromCountryCode(countryCode);
  // console.log(mobileNumber,'mobilenumber')
  const phoneNumberWithDialingCode = `+${mobileNumber}`;
  const formattedPhoneNumber = formatPhoneNumberIntl(phoneNumberWithDialingCode);
  return formattedPhoneNumber;
};

export function formattedDate(date) {
  return moment(date, 'MM-DD-YYYY HH:mm:ss').format('YYYY-MM-DD');
}
export function convertValueintoInternationalSystem(value) {
  if (Math.abs(value) >= 1e12) {
    return (value / 1e12).toFixed(2) + 'T'; // Trillions
  } else if (Math.abs(value) >= 1e9) {
    return (value / 1e9).toFixed(2) + 'B'; // Billions
  } else if (Math.abs(value) >= 1e6) {
    return (value / 1e6).toFixed(2) + 'M'; // Millions
  } else if (Math.abs(value) >= 1e3) {
    return formatCurrency(value / 1e3) + 'K'; // Thousands
  } else {
    return formatCurrency(value); // Fallback for smaller values
  }
}

export const formatTotalAmount = (amount) => {
  if (!amount || amount === '0') return 0; // Handle empty or zero values

  const numericValue = parseFloat(amount.replace(/[^0-9.]+/g, '')); // Extract numeric value

  if (amount.endsWith('M')) {
    return numericValue * 1e6; // Convert millions
  } else if (amount.endsWith('K')) {
    return numericValue * 1e3; // Convert thousands
  } else {
    return numericValue; // Return the number itself
  }
};

export const formatCurrency = (num) => {
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const roles = [
  'All',
  'Assigned',
  'Unassigned',
  'Used',
  'Unused',
  'Active',
  'Suspended',
  'Expired',
];
export const status = ['All', 'Active', 'Inactive', 'Subscribed', 'Not Subscribe'];


export const checkingGreaterValue = (data) => {
  if (!Array.isArray(data?.truckingRangeList) || data?.truckingRangeList.length === 0) {
    return false;
  }


  return data.truckingRangeList.some((item) => {

    if (item?.selectedTrucking === "dollar") {
      const min = Number(item?.truckingMinMarginDollar);
      const margin = Number(item?.truckingMarginDollar);

      if (isNaN(min) || isNaN(margin)) return false;

      return min > margin;
    }

    if (item?.selectedTrucking === "percentage") {
      const min = Number(item?.truckingMinMarginPercentage);
      const margin = Number(item?.truckingMarginPercentage);

      if (isNaN(min) || isNaN(margin)) return false;

      return min > margin;
    }

    return false;
  });
};
export const handleModalTrigger = (height, chooseUnit, i, triggeredIndexesRef, setShowModal) => {
  let heightThreshold;
  if (chooseUnit === 'Imperial' || chooseUnit === 'Imperial / Metric') {
    heightThreshold = 63; // 63 inches for Imperial
  } else if (chooseUnit === 'Metric') {
    heightThreshold = 160; // 160 cm for Metric
  }
  const shouldTriggerModal = height > heightThreshold;

  if (shouldTriggerModal && !triggeredIndexesRef.current[i]) {
    triggeredIndexesRef.current[i] = true;
    setShowModal(true);
  }

  if (!shouldTriggerModal && triggeredIndexesRef.current[i]) {
    triggeredIndexesRef.current[i] = false; // Reset the flag
  }
};
export const statisticColors = ['#0A8FDC', '#49BD65', '#9E49E6', '#3A3849', '#ffa07a', '#DC143C'];
// export const tempUnitNames=['-25C°','+2C°/+8C°','+15C°/+25C°']
export const tempUnitNames = ['-25\u00b0C', '+2\u00b0C/+8\u00b0C', '+15\u00b0C/+25\u00b0C'];

export function extractLocation(address) {
  // Split the address by commas
  let parts = address.split(',');

  // Check if there are at least 3 parts (city, country, and some extra info)
  if (parts.length >= 3) {
    // Return the city and country part, which are the second and third parts
    return parts[1].trim() + ',' + parts[2].trim();
  } else {
    // If the format is not as expected, return a fallback or empty string
    return ' ';
  }
}

export const handleOnclose = (setOpenDialog) => {
  setOpenDialog(false);
};

export const Roles = [
  { label: 'All', value: 'ALL' },
  { label: 'FF Agent', value: 'ROLE_FFAGENT' },
  { label: 'FF Client', value: 'ROLE_FFCLIENT' },
  { label: 'Consignee', value: 'ROLE_CONSIGNEE' },
  { label: 'FF Admin', value: 'ROLE_FFADMIN' },
  { label: 'Airline Admin', value: 'ROLE_AIRLINE_ADMIN' },
  { label: 'Airline Agent', value: 'ROLE_AIRLINE_AGENT' },
];

export const AircraftType = ['Narrowbody', 'Widebody', 'Freighter'];

export const buildColumnDefs = (
  columnSequence,
  role,
  ViewCellRenderer,
  COLUMN_BEHAVIOR,
  matchesMD,
  extraColumns = []
) => {
  const cols = columnSequence.map((col) => {
    const behavior = COLUMN_BEHAVIOR[col.field];
    const colDef = {
      headerName: col.headerName,
      field: col.field,
      tooltipField: col.field,

      sortable: true,
      filter: true,
      floatingFilter: true,
      resizable: true,

      flex: 1,
      width: 220,
      minWidth: 220,
    };

    /* DATE FORMAT */
    if (col.field === 'createdDate') {
      colDef.valueFormatter = (params) =>
        params.value ? moment(params.value).format('MM/DD/YYYY HH:mm:ss') : '';
    }

    /* CURRENCY FORMAT */
    if (
      ['totalAmount', 'totalMarginDoller', 'totalMarginDoller2', 'totalAmount2'].includes(col.field)
    ) {
      colDef.valueFormatter = (params) =>
        params.value != null
          ? `$${parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
          : '-';
      colDef.cellStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center' };
    }

    // Handle originZipcode column
    if (col.field === 'originZipcode') {
      colDef.valueGetter = (params) => {
        if (params.data) {
          return params.data.originCity && params.data.originCity !== '-'
            ? `${params.data.originCity} ${params.data.originZipcode}`
            : '-,-';
        }
        return '';
      };
    }

        if (col.field === 'clientType') {
      colDef.tooltipField = 'clientType';

      colDef.valueGetter = (params) => {
        if (role === 'client') {
          return params?.data?.clientType;
        }
        return params?.data?.keyType;
      };
    }

    // Handle destinationZipcode column
    if (col.field === 'destinationZipcode') {
      colDef.valueGetter = (params) => {
        if (params.data) {
          return params.data.destinationCity && params.data.destinationCity !== '-'
            ? `${params.data.destinationCity} ${params.data.destinationZipcode}`
            : '-,-';
        }
        return '';
      };
    }

    if (role == 'FF Client' &&col.field=='conformationStatus')
    {
      colDef.cellStyle = (params) => {
        const status = params.data?.conformationStatus;
        let color = '#000000'; // default black

        if (status === 'FF Accepted') color = '#00cc00';
        // green
        else if (['FF Rejected', 'CFF Cancelled', 'FF Cancelled'].includes(status))
          color = '#c90c32';
        // red
        else if (['CFF Confirmed', 'FF Confirmed'].includes(status)) color = '#ff6600';
        // orange
        else if (status === 'FF Recalculated') color = '#000000';
        // black
        else color = '#F1C40F'; // default yellow

        return { color, };
      };
    }

    /* 🔵 CLICKABLE INQUIRER */
    if (behavior?.clickable) {
      colDef.cellStyle = {
        color: behavior.color,
        cursor: 'pointer',
      };
      colDef.onCellClicked = behavior.onClick;
    }

    return colDef;
  });

  /* 👁️ VIEW COLUMN (NOT FROM BACKEND) */
  if(ViewCellRenderer!=null)
  if (role == 'FF Client') {
    cols.push({
      headerName: 'View',
      colId: 'view', // ✅ REQUIRED for non-data column

      // field: '',
      // valueGetter: () => '',
      flex: 1,
      width: 220,
      minWidth: 150,

      pinned: matchesMD ? 'right' : null,
      suppressMovable: true,
      cellRendererFramework: ViewCellRenderer,
    });
  } else {
    cols.push({
      headerName: 'View',
      colId: 'view', // ✅ REQUIRED for non-data column

      // field: '',
      // valueGetter: () => '',
      flex: 1,
      width: 90,
      minWidth: 90,

      pinned: matchesMD ? 'right' : null,
      suppressMovable: true,
      cellRendererFramework: ViewCellRenderer,
    });
  }
   if (extraColumns.length) {
    return [...extraColumns, ...cols]; // ✅ Inject at beginning
  }

  return cols;
};



  const getColorBasedOnStatus = (status) => {
    switch (status?.toLowerCase()) {
      case 'suspend':
        return '#FFA500'; // Orange
      case 'active':
        return '#00e500'; // Green
      case 'expired':
        return '#FF0000'; // Red
      default:
        return '#0C6AC9'; // Default color (Blue)
    }
  };


export const keyColumn = {
  headerName: '',
  field: 'keyAction',
  width: 90,
  minWidth: 90,
  pinned: 'left',
  suppressMovable: true,
  sortable: false,
  filter: false,
  cellRendererFramework: (params) => (
    <Grid className="row">
      <Tooltip title="Key" placement="bottom" arrow>
        <button className="grid-edit-button mt-20">
          <KeyOutlinedIcon
            style={{
              color: getColorBasedOnStatus(params?.data?.activeStatus),
            }}
          />
        </button>
      </Tooltip>
    </Grid>
  ),
};
 const airTypeChargeSchema = Yup.object().shape({
      length: Yup.number()
        .typeError("Length must be a number")
        .required("*Required")
        .min(0, "Length cannot be negative"),

      width: Yup.number()
        .typeError("Width must be a number")
        .required("*Required")
        .min(0, "Width cannot be negative"),

      height: Yup.number()
        .typeError("Height must be a number")
        .required("*Required")
        .min(0, "Height cannot be negative"),

      weight: Yup.number()
        .typeError("Weight must be a number")
        .required("*Required")
        .min(0, "Weight cannot be negative"),
    })
export const validationSchemaforairtypecharge = Yup.object({
  airtypecharge: Yup.array()
    .of(airTypeChargeSchema),
});


// Utility function (can put in a separate utils.js if you want)
// export function isIOSDevice() {
//   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//   const platform = navigator.platform || "";

//   // iPad detection (including iPadOS 13+ Safari)
//   const isiPad = platform === "iPad" || (platform === "MacIntel" && navigator.maxTouchPoints > 1);

//   const isiPhone = /iPhone/.test(userAgent) && !window.MSStream;
//   const isiPod = /iPod/.test(userAgent) && !window.MSStream;

//   return isiPad || isiPhone || isiPod;
// }

// export function isIOSDevice() {
//   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//   const platform = navigator.platform || "";

//   // iPad detection
//   const isiPad =
//     /iPad/.test(userAgent) ||                       // older iPads
//     (platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS 13+ Safari

//   // iPhone / iPod detection
//   const isiPhone = /iPhone/.test(userAgent) && !window.MSStream;
//   const isiPod = /iPod/.test(userAgent) && !window.MSStream;

//   return isiPad || isiPhone || isiPod;
// }

export function isIOSDevice() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const platform = navigator.platform || "";

  // 1. iPhone / iPod detection
  const isiPhone = /iPhone/.test(ua) && !window.MSStream;
  const isiPod = /iPod/.test(ua) && !window.MSStream;

  // 2. iPad detection (works on old iPads)
  const isiPadLegacy = /iPad/.test(ua);

  // 3. iPadOS 13+ detection (Safari Desktop Mode)
  const isiPadOS13 = (platform === "MacIntel" && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);

  return isiPhone || isiPod || isiPadLegacy || isiPadOS13;
}

 export const handleReset = (setFieldValue,values) => {
  const updated = values.airtypecharge.map((item, index) => ({
    ...item,
    length: 0,
    width: 0,
    weight: 0,
    height: 0 
  }));

  setFieldValue("airtypecharge", updated);
};

export const restrictedUsers = [
  'All Admins',
  'All Agents',
  'All Consignees',
  'All Clients'
];

export const roleMap = {
  'All Admins': 'Freight Forwarder Admin',
  'All Agents': 'Freight Forwarder Agent',
  'All Consignees': 'Client Consignee/Shipper',
  'All Clients': 'Client Freight Forwarder',
};




export const commonPrintPDF = (fileURL, fileName) => {
  const originalTitle = document.title;
  let titleTimer = null;

  document.title = fileName;

  printJS({
    printable: fileURL,
    type: 'pdf',
    onPrintDialogClose: () => {
      if (titleTimer) {
        clearTimeout(titleTimer);
        titleTimer = null;
      }
      document.title = originalTitle;
      window.URL.revokeObjectURL(fileURL);
    },
    onLoadingEnd: () => {
      titleTimer = setTimeout(() => {
        document.title = originalTitle;
        titleTimer = null;
      }, 1000);
    }
  });
};


export const getDashboardUrl = (role) => {
  switch (role) {
    case 'ROLE_CONSIGNEE': return '/shipper/quotation/create';
    case 'ROLE_FFADMIN': return '/freight-forwarder/admin/quotation/create';
    case 'ROLE_SUPERADMIN': return '/super-admin/freight-forwarder/companies/approved-companies';
    case 'ROLE_AIRLINE_ADMIN': return '/airline/admin/profile/update';
    case 'ROLE_AIRLINE_AGENT': return '/airline/agent/priority-rate/create';
    case 'ROLE_FFAGENT': return '/freight-forwarder/agent/quotation/create';
    case 'ROLE_DATAENTRY': return '/data-entry/airfare/create';
    case 'ROLE_TRUCKING_ADMIN': return '/trucking/statistics';
    case 'ROLE_FFCLIENT': return '/freight-forwarder/client/quotation/create';
    default: return '/sign-in'; // fallback for guests
  }
};

export const handleDuplicateGoods = (
  item,
  index,
  arrayHelpers
) => {
  const duplicatedGoods = {
    ...item,

    hazmatDto:
      item?.hazmatDto?.map((hazmat) => ({
        ...hazmat,
      })) || [],

    temperatureControlledDTOS:
      item?.temperatureControlledDTOS?.map((temp) => ({
        ...temp,
      })) || [],

    oversizedDTOS:
      item?.oversizedDTOS?.map((oversized) => ({
        ...oversized,
      })) || [],
  };

  arrayHelpers.insert(index + 1, duplicatedGoods);
};